var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from "styled-components";
import { T, FONT } from "../admin.theme";
var TONES = {
    success: { fg: T.success, bg: T.successTint },
    danger: { fg: T.danger, bg: T.dangerTint },
    info: { fg: T.info, bg: T.infoTint },
    accent: { fg: T.accent, bg: T.accentTint },
    muted: { fg: T.textMuted, bg: "rgba(255,255,255,0.05)" },
    purple: { fg: "#C879E8", bg: "rgba(200,121,232,0.14)" },
};
var Badge = styled.span(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 5px 10px;\n  border-radius: ", "px;\n  font-family: ", ";\n  font-size: 12px;\n  font-weight: 500;\n  line-height: 1;\n  width: fit-content;\n  color: ", ";\n  background: ", ";\n"], ["\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 5px 10px;\n  border-radius: ", "px;\n  font-family: ", ";\n  font-size: 12px;\n  font-weight: 500;\n  line-height: 1;\n  width: fit-content;\n  color: ", ";\n  background: ", ";\n"])), T.radiusPill, FONT.body, function (_a) {
    var $tone = _a.$tone;
    return TONES[$tone].fg;
}, function (_a) {
    var $tone = _a.$tone;
    return TONES[$tone].bg;
});
var Dot = styled.span(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  background: ", ";\n"], ["\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  background: ", ";\n"])), function (_a) {
    var $tone = _a.$tone;
    return TONES[$tone].fg;
});
// Бейдж-статус из макета: точка + текст, тонированный фон.
export var StatusBadge = function (_a) {
    var _b = _a.tone, tone = _b === void 0 ? "muted" : _b, _c = _a.dot, dot = _c === void 0 ? true : _c, children = _a.children;
    return (_jsxs(Badge, { "$tone": tone, children: [dot && _jsx(Dot, { "$tone": tone }), children] }));
};
var templateObject_1, templateObject_2;
